import React, {useEffect, useState} from 'react';
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import {Flex} from "reflexbox";

import {Close, Check} from "@mui/icons-material";
import CardMedia from "@mui/material/CardMedia";
import PropTypes from 'prop-types';

const MixAndMatch = (props) => {
  const {setUserAnswer, pastAnswers, complete, setDisableSubmit, userActions, error, setError, correct} = props;
  const items = props.initialCards;
  const images = props.initialImages;

  let initialUserAnswer = [];
  items.map(()=>initialUserAnswer.push('')); // example result ['','','','']

  const [unselectedCards, setUnselectedCards] = useState(items);
  const [userSelection, setUserSelection] = useState(initialUserAnswer);
  const [selected, setSelected] = useState(null);

  useEffect(()=>{
    //setting of the user answer in parent container when the user moves things around
    setUserAnswer(userSelection);
    }, [userSelection]);

  useEffect(()=>{
    //logic on whether to disable the submit button
    //check to make sure there are four cards selected
    if(JSON.stringify(unselectedCards) === JSON.stringify(initialUserAnswer)  && !pastAnswers.includes(userSelection.toString()) && !complete ) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true)
    }
  },[userSelection, userActions]);

  const minHeight = '59px';
  const imageCardHeight = '100px';
  //colors
  const startColor = '#96000e1a';
  const selectedColor = '#00599680';
  const semiTransparentBlack = '#00000080';

  const baseStyle = {
    padding: '8px',
    textAlign: 'center',
    minHeight: minHeight,
  };

  const cardWrapperStyle = {
    width: '50%', padding: '8px', boxSizing: 'border-box'
  };

  const handleMoveHere = (index) => {
    if (selected && userSelection[index] === '') {
      const selectedLocation = unselectedCards.indexOf(selected);
      const newStartList = [...unselectedCards];
      const newFinishedList = [...userSelection];
      //add the replace functionality here if we want it
      newStartList[selectedLocation] = '';
      setUnselectedCards(newStartList);
      newFinishedList[index] = selected;
      setUserSelection(newFinishedList);
      setSelected(null);
    }
  };

  const handleMoveBack = (index) => {
    const newStartList = [...unselectedCards];
    const newFinishedList = [...userSelection];
    const item = userSelection[index];
    newStartList[items.indexOf(item)] = item;
    newFinishedList[index] = '';
    setUnselectedCards(newStartList);
    setUserSelection(newFinishedList);
    setSelected(null);
    error && setError(false);
  };

  const numRemaining = userSelection.filter(el => el === '').length;

  return (
    <>
      <hr />
      <Typography style={{textAlign: 'center', fontWeight: 'bold', marginTop: '16px'}}>Tap the name </Typography>
      {numRemaining <5 && <Typography variant={'caption'} style={{textAlign: 'center', display: 'flex', justifyContent: 'center' }}>{numRemaining} remain{numRemaining === 1 && 's'}! </Typography>}
      <Flex style={{flexWrap: 'wrap'}}>
        {unselectedCards.map((el, index) => {
          return <div key={index} style={cardWrapperStyle}>
            <Card onClick={() => el && setSelected(selected === el ? null : el)}
                  style={{
                    ...baseStyle,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: el === selected ? selectedColor : el ? startColor : semiTransparentBlack
                  }}>
              {el ? <Typography style={{height: '100%'}}>{el}</Typography> : <Flex style={{
                width: '100%',
                height: minHeight,
                justifyContent: 'center',
                alignItems: 'center'
              }}><Check/></Flex>}
            </Card>
          </div>
        })}
      </Flex>

      <Typography style={{textAlign: 'center', fontWeight: 'bold', marginTop: '16px'}}>Then tap the matching picture </Typography>
      <Flex style={{flexWrap: 'wrap'}}>
        {userSelection.map((el, index) => {
          return (
            <div key={index} id={'card-wrapper'} style={cardWrapperStyle}>
              <Card id={'image card'} style={{width: '100%', height: imageCardHeight}}>
                <CardMedia
                  component="img"
                  image={images[index]}
                  title={'image'}
                  height={imageCardHeight}
                  // style={{width: '100%'}}
                />
              </Card>
              <div style={{height: 0, position: 'relative', bottom: imageCardHeight}}>
                <Card id={'image-overlay'}
                      onClick={() => handleMoveHere(index)}
                      style={{
                        height: imageCardHeight,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        opacity: (el || selected) ? 1 : 0,
                        backgroundColor: el ? semiTransparentBlack : selectedColor,
                        border: (selected && !el) ? '2px dashed darkgray' : null,
                        boxSizing: 'border-box',
                      }}>
                  {el &&
                  <Flex style={{flexDirection: 'column', height: '100%', width: '100%', justifyContent: 'flex-start'}}>
                    <Flex style={{justifyContent: 'flex-end', height: 0, zIndex: 2}}>
                      <Close fontSize={'small'} style={{color: 'darkgray', marginRight: '3px'}}
                             onClick={() => handleMoveBack(index)}/>
                    </Flex>
                    <Flex style={{ padding: '8px', height: '100%'}}>
                      <Typography id={'overlay-text'} style={{display: 'flex', color: 'white', opacity: 1, justifyContent: 'center', alignItems: 'center', width: '100%', fontWeight: 'bold'}}>{el}</Typography>
                    </Flex>
                  </Flex>}
                  {(!el && selected) && <span style={{fontStyle: 'italic', color: 'white'}}>Tap to move here</span>}
                </Card>
              </div>
            </div>)
        })}
        <Flex style={{justifyContent: 'center', alignItems: 'center', width: '100%', flexDirection: 'column'}}>
          {error && <Typography variant={'contained'} color={'secondary'} style={{margin: '8px'}}> Incorrect! Try again</Typography>}
          {pastAnswers.length > 0 && <Typography variant={'caption'}>Incorrect attempts: {pastAnswers.length - (correct ? 1 : 0)}</Typography>}
        </Flex>

      </Flex>
    </>
  )
};

MixAndMatch.propTypes = {
  setUserAnswer: PropTypes.func.isRequired,
  error: PropTypes.bool,
  initialCards: PropTypes.array.isRequired,
  initialImages: PropTypes.array.isRequired,
};

export default MixAndMatch;